/**
 * PRP-MCP-9 work item 8 (G7): the admin user list's access columns: plan,
 * founder, active grants, last chat activity. Rendered by the Users tab of
 * `AdminPage.tsx` from `AdminUserAccessAPI.summary()`; its own file because
 * `AdminPage.tsx` sits at its god-file ceiling.
 */
import React from 'react';

import type { UserAccessSummary } from '../../lib/adminUserAccessApi';

export const ACCESS_COLUMN_COUNT = 4;

const fmtDate = (iso: string | null) => (iso ? new Date(iso).toLocaleDateString() : '—');

export const AccessHeaderCells: React.FC = () => (
  <>
    <th className="px-3 py-2">Plan</th>
    <th className="px-3 py-2">Founder</th>
    <th className="px-3 py-2 text-right">Grants</th>
    <th className="px-3 py-2 text-right">Last chat</th>
  </>
);

/** The four cells for one user; dashes while the summary has not loaded (or failed). */
export const AccessCells: React.FC<{ access?: UserAccessSummary }> = ({ access }) => (
  <>
    <td className="px-3 py-3">{access?.plan_name || '—'}</td>
    <td className="px-3 py-3">{access?.founder ? `Until ${fmtDate(access.founder_until)}` : '—'}</td>
    <td className="px-3 py-3 text-right">{access?.grants_count || '—'}</td>
    <td className="px-3 py-3 text-right">{access?.last_chat_at?.slice(0, 10) || '—'}</td>
  </>
);
